import { app } from '../shared';

export const fetchUserPartyPeriodPostImpressions = async () => {
  return app.service('user-party-period-postimpressions').find({});
};
